import { render, staticRenderFns } from "./ActivePrograms.vue?vue&type=template&id=84f7c230&scoped=true&"
import script from "./ActivePrograms.vue?vue&type=script&lang=ts&"
export * from "./ActivePrograms.vue?vue&type=script&lang=ts&"
import style0 from "./ActivePrograms.less?vue&type=style&index=0&id=84f7c230&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84f7c230",
  null
  
)

export default component.exports